/**
 * Get browser locale
 * @returns {string}
 */
const getBrowserLocale = (): string => {
  return navigator.languages ? navigator.languages[0] : navigator.language || '';
};

export default getBrowserLocale;
